
////////////////////// EVENT TRIGGERS + LISTENERS //////////////////////

if (!window.cache) {
  window.cache = {};
  window.getCacheItem = (key) => cache[key];
  window.setCacheItem = (key, value) => {
    window.cache[key] = value;
    // console.log('cache is now:', window.cache);
  }
}


(() => {
  // Global cache
  const _cache = {};
  getCacheItem = (key) => _cache[key];
  setCacheItem = (key, value) => {
    _cache[key] = value;
    // console.log('_cache is now:', _cache);
  }

  
  if (!window.m) window.m = {};
  /////////
  const triggerEvent = (EVENT_NAME, data) => document.dispatchEvent(new CustomEvent(EVENT_NAME, {detail:{...data}}));
  const listenToEvent = (EVENT_NAME, listener) => document.addEventListener(EVENT_NAME, e => listener(e.detail));
  ////////


  m.getActiveDiscountCode = () => {
    const url_params = new URLSearchParams(window.location.search);
    const discount_from_url = url_params.get('discount');
    const discount_from_cookie = getCookie('my_discount_code');
    let discount_code = discount_from_url || discount_from_cookie;
    // console.log({discount_from_url, discount_from_cookie, discount_code});
    if (discount_code === 'REMOVE_DISCOUNT_CODES') discount_code = null;
    return discount_code;
  }

  m.applyDiscountCode = (discount_code) => {
    if (!discount_code) {
      console.log('Cannot apply empty discount code', {discount_code});
      return;
    }
    console.log('Applying discount code & redirect', {discount_code});
    const base_url = window.location.href.split('?')[0];
    const url_search_params = new URLSearchParams(window.location.search);
    url_search_params.set('discount', discount_code);
    const target_url = base_url+'?'+url_search_params.toString();
    // console.log({target_url,url_search_params});
    window.location.href = target_url;
  }

  ////////

  m.getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
  }

  m.setCookie = (name, value, days) => {
    let expires = "";
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
  }

  m.deleteCookie = (name) => {   
    document.cookie = name + '=; expires=' + new Date(0).toUTCString();  
  }

  ////////

  m.getUrlParam = (key) => {
    const url_params = new URLSearchParams(window.location.search);
    return url_params.get(key);
  }

  m.setUrlParam = ({key, value, shouldRefresh}) => {
    const url_params = new URLSearchParams(window.location.search);
    url_params.set(key, value);
    const base_url = window.location.href.split('?')[0];
    const target_url = `${base_url}?${url_params.toString()}`;
    if (shouldRefresh) {
      window.location.href = target_url;
    } else {
      window.history.pushState(null, '', target_url);      
    }
  }
  
  m.deleteUrlParam = ({key, shouldRefresh}) => {
    const url_params = new URLSearchParams(window.location.search);
    url_params.delete(key);
    const base_url = window.location.href.split('?')[0];
    const target_url = `${base_url}?${url_params.toString()}`;
    if (shouldRefresh) {
      window.location.href = target_url;
    } else {
      window.history.pushState(null, '', target_url);      
    }
  }

  /////////
  
  const SELECT_MARKET_EVENT = 'SELECT_MARKET_EVENT';
  m.selectMarket = async (market) => {
    triggerEvent(SELECT_MARKET_EVENT, {market});
  }
  m.onSelectedMarket = (listener) => listenToEvent(SELECT_MARKET_EVENT, listener);
  
  const SELECT_LANGUAGE_EVENT = 'SELECT_LANGUAGE_EVENT';
  m.selectLanguage = async ({language}) => {
    triggerEvent(SELECT_LANGUAGE_EVENT, {language});
  }
  m.onSelectedLanguage = (listener) => listenToEvent(SELECT_LANGUAGE_EVENT, listener);
  
  ////////
  
  const VARIANT_ID_URL_PARAM = 'variant';
  m.getProductVariantId = () => {
    const url_params = new URLSearchParams(window.location.search);
    return url_params.get(VARIANT_ID_URL_PARAM);
  }

  const SELECT_PRODUCT_VARIANT_EVENT = 'SELECT_PRODUCT_VARIANT_EVENT';
  let _selected_product_variant = null;
  m.selectProductVariant = ({product_id, variant_id}) => {
    // var url = new URL(window.location);
    // url.searchParams.set(VARIANT_ID_URL_PARAM, variant_id);
    // window.history.pushState({}, '', url);
    _selected_product_variant = variant_id;
    triggerEvent(SELECT_PRODUCT_VARIANT_EVENT, {product_id, variant_id});
  }
  m.onSelectedProductVariant = (listener) => listenToEvent(SELECT_PRODUCT_VARIANT_EVENT, listener);


  

  
  const PRODUCT_STOCK_LOADED_EVENT = 'PRODUCT_STOCK_LOADED_EVENT';
  
  // let _cached_product_stock_data = null;
  const product_stock_loading = {};
  const product_stock_cache = {};
  const generateProductStockCacheKey = ({product_handle,country,language}) => {
    let cache_key = product_handle;
    if (country) cache_key += '-' + country;
    if (language) cache_key += '-' + language;
    return cache_key;
  }
  const getProductStockFromCache = ({product_handle,country,language}) => {
    const cache_key = generateProductStockCacheKey({product_handle,country,language});
    return product_stock_cache[cache_key];
  }
  const setProductStockCache = ({product_handle,country,language, data}) => {
    const cache_key = generateProductStockCacheKey({product_handle,country,language});
    product_stock_cache[cache_key] = data;
  }
  m.getProductStockCache = () => product_stock_cache;
  
  m.getProductStock = ({product_handle,country,language}) => {
    return getProductStockFromCache({product_handle,country,language});
  }
  m.getProductStockVariant = (variant_id) => {
    const variants = Object.keys(product_stock_cache).reduce((acc, key) => {
      product_stock_cache[key]?.variants?.forEach(variant => acc.push(variant));
      return acc;
    }, []);
    return variants.find(variant => variant.id == variant_id);
    // return _cached_product_stock_data.variants.find(_ => _.id == variant_id);
  }
  m.loadProductStock = async ({product_handle, country, language}) => {
    const loading_key = generateProductStockCacheKey({product_handle,country,language});
    if (product_stock_loading[loading_key]) return;
    product_stock_loading[loading_key] = true;
    
    const cached_product_stock = getProductStockFromCache({product_handle,country,language});
    if (cached_product_stock) return cached_product_stock;
    // if (_cached_product_stock_data) return _cached_product_stock_data;
    let endpoint = `https://api2.moonbird.life/products/${product_handle}/stock?country=${country}`;
    if (language) endpoint += `&language=${language}`;
    const data = await fetch(endpoint).then(_ => _.json());
    // product_stock_cache[generateProductStockCacheKey({product_handle,country,language})] = data;
    setProductStockCache({product_handle,country,language,data});
    // _cached_product_stock_data = data;
    // Trigger global event for all listeners
    triggerEvent(PRODUCT_STOCK_LOADED_EVENT, data);
    //////////////////////////////////////////
    return data;
  }
  m.onLoadedProductStock = (listener) => listenToEvent(PRODUCT_STOCK_LOADED_EVENT, listener);

  m.getFirstProductVariantInStock = ({variants}) => {
    const available_variants = variants.filter(variant => variant.available);
    return available_variants[0];
    // console.log('getFirstProductVariantInStock', {available_variants});
    // const not_popular_available_variants = available_variants.filter(variant => !variant.is_hot);
    // return not_popular_available_variants[0];
  }

  m.selectFirstProductVariantInStock = ({variants}) => {
    const target_product_variant = m.getFirstProductVariantInStock({variants}) || variants[0];
    if (!target_product_variant) return;
    m.selectProductVariant({product_id: target_product_variant.product_id, variant_id: target_product_variant.id});
  }
  
  m.selectFirstBestProductVariant = async ({variants}) => {
    const product_variant_id_from_url = m.getProductVariantId();
    
    if (!product_variant_id_from_url) {
      m.selectFirstProductVariantInStock({variants});
    } else {
      const all_product_variant_ids = variants.map(_ => _.id);
      const product_id = variants?.[0]?.product_id;
      if (all_product_variant_ids.includes(product_variant_id_from_url)) {
        m.selectProductVariant({variant_id: product_variant_id_from_url});            
      } else {
        m.selectProductVariant({variant_id: variants[0].id});
      }
    }
  }

  const PRODUCT_VARIANT_PRICE_LOADED_EVENT = 'PRODUCT_VARIANT_PRICE_LOADED_EVENT';
  m.loadProductVariantPrice = async ({discount_code, variant_id, country}) => {
    const busy_cache_key = `${discount_code}-${variant_id}-${country}-busy`;
    const data_cache_key = `${discount_code}-${variant_id}-${country}-data`;
    if (getCacheItem(data_cache_key)) {
      triggerEvent(PRODUCT_VARIANT_PRICE_LOADED_EVENT, getCacheItem(data_cache_key));      
      return;
    }
    
    if (getCacheItem(busy_cache_key)) return;
    setCacheItem(busy_cache_key, true);

    const endpoint = `https://api2.moonbird.life/discount/${discount_code}?product_variant_id=${variant_id}&country=${country}`;
    const data = await fetch(endpoint).then(_ => _.json());
    setCacheItem(data_cache_key, data);
    // console.log('loadProductVariantPrice', { data });
    triggerEvent(PRODUCT_VARIANT_PRICE_LOADED_EVENT, data);
  }
  m.onLoadedProductVariantPrice = (listener) => listenToEvent(PRODUCT_VARIANT_PRICE_LOADED_EVENT, listener);


  
  const PRODUCT_PRICE_LOADED_EVENT = 'PRODUCT_PRICE_LOADED_EVENT';
  m.loadProductPrice = async ({discount_code, product_handle, country, language}) => {
    // console.log({discount_code, product_handle, country, language});
    const busy_cache_key = `${discount_code}-${product_handle}-${country}-${language}-busy`;
    const data_cache_key = `${discount_code}-${product_handle}-${country}-${language}-data`;
    if (getCacheItem(data_cache_key)) {
      triggerEvent(PRODUCT_PRICE_LOADED_EVENT, getCacheItem(data_cache_key));      
      return;
    }
    
    if (getCacheItem(busy_cache_key)) return;
    setCacheItem(busy_cache_key, true);

    let endpoint = `https://api2.moonbird.life/products/${product_handle}/price?country=${country}&language=${language}`;
    if (discount_code) endpoint += `&discount=${discount_code}`;
    const data = await fetch(endpoint).then(_ => _.json());
    setCacheItem(data_cache_key, data);
    // console.log('loadProductPrice', { data });
    triggerEvent(PRODUCT_PRICE_LOADED_EVENT, data);
  }
  m.onLoadedProductPrice = (listener) => listenToEvent(PRODUCT_PRICE_LOADED_EVENT, listener);

  /////////

  m.changeMarket = async ({country, language}) => {
    if (!country) return console.log('Country cannot be empty');
    if (!language) return console.log('Language cannot be empty');
    
    deleteCookie('OptanonAlertBoxClosed');
    deleteCookie('OptanonConsent');
    setCookie('my_country', country, 30);
    setCookie('my_language', language, 30);
    
    const formId = crypto.randomUUID();
    const formHtml = `
      <form id="${formId}" action="/localization" method="POST" hidden>
        <input name="_method" value="PUT">
        <input type="hidden" name="return_to" value="${window.location.href}">
        <input name="country_code" value="${country}">
        <input name="language_code" value="${language}">
      </form>
    `;
    
    document.body.insertAdjacentHTML("beforeend", formHtml);
  
    setTimeout(function() {
      deleteCookie('OptanonAlertBoxClosed');
      deleteCookie('OptanonConsent');
      document.getElementById(formId).submit();
    }, 100);
  }  
})();
